// extracted by mini-css-extract-plugin
export default {"requestsCard":"workroom_requestsCard__XckHf","masterData":"workroom_masterData__MSouq"};